import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import SoundPlayerBar from "./modules/SoundPlayerBar";
import { bookSoundPlayerState } from "@stores/popup";
import { useAtom } from "jotai";
import anime from "animejs";
import Draggable from "react-draggable";

const Wrap = styled.div`
  position: absolute;
  left: calc(50% + 51px);
  transform: translateX(-50%);
  bottom: 195px;
  z-index: 10;
  align-items: center;
  display: flex;
  justify-content: center;
}
`;

const DragArea = styled.div`
  position: absolute;
  width: 84px;
  height: 100%;
  margin-left: -100px;
  top: 0;
  left: 0;
  background-color: var(--theme-color);
  border-radius: 20px;
  box-sizing: border-box;
  box-shadow: 4px 4px 0px 1px rgb(0 0 0 / 30%);
  &:after {
    content: "";
    position: absolute;
    background: url(${require("@assets/img/dnd-icon.png")}) no-repeat;
    width: 100%;
    height: 100%;
    background-size: 60%;
    background-position: center center;
  }
`;

const BookSoundPlayer = () => {
  const [sound, setSound] = useAtom(bookSoundPlayerState);
  const ref = useRef(null);
  const soundWrapRef = useRef(null);
  const isFirstPage = document.querySelector("#flipbook");
  useEffect(() => {
    anime({
      targets: soundWrapRef.current,
      translateY: [50, 0],
      translateX: ["-50%", "-50%"],
      opacity: [0, 1],
    });
    const b = document.querySelectorAll(".book-sound-button");
    if (b.length > 0) {
      b.forEach((el) => {
        el.style.display = "none";
      });
    }
    return () => {
      const b = document.querySelectorAll(".book-sound-button");
      if (b.length > 0) {
        b.forEach((el) => {
          el.style.display = "block";
        });
      }
    };
  }, []);

  return (
    <Wrap className="bookmode" ref={soundWrapRef}>
      <Draggable
        nodeRef={ref}
        onStart={() => {}}
        onStop={() => {}}
        handle="#s_handle"
        offsetParent={soundWrapRef.current}
        position={null}
        scale={window.__scale}
        bounds={{ left: -539, top: -737, right: 533, bottom: 4 }}
        disabled={isFirstPage.classList.contains("first-page")}
      >
        <div ref={ref}>
          <DragArea id="s_handle" />
          <SoundPlayerBar
            cName="bookmode"
            url={sound.url}
            onEnd={() => {
              setSound({
                open: false,
                url: "",
              });
            }}
            onClose={() => {
              setSound({
                open: false,
                url: "",
              });
            }}
          />
        </div>
      </Draggable>
    </Wrap>
  );
};

export default React.memo(BookSoundPlayer);
